var a=function(a,r,t){var e=0;return a&&("number"==typeof a&&(e=a),"function"==typeof a&&(e=a(r,t))),e},r={display:"grid",gridTemplateColumns:"var(--data-table-library_grid-template-columns)"};export{r as S,a as g};
//# sourceMappingURL=index-8b7392ea.js.map
